export const formatFloatToStr = (value: number | null | undefined) => {
    if (typeof value !== 'number' || isNaN(value)) return '0.00';
    return value.toFixed(2).toString().replace('.', ',');
}
